import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { VideoService } from '../video/video.service';

export const participantVideoResolver: ResolveFn<Object> = async (route) => {
  const service = inject(VideoService);
  return await service.getAllParticipantVideos();
};
